import { j as o } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { faTableRows as r } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as n } from "@fortawesome/react-fontawesome";
import { styled as e, Button as m } from "@mui/joy";
import { memo as a } from "react";
const s = e(m)(({
  theme: t
}) => ({
  "& .MuiButton-startDecorator": {
    "& > svg": {
      color: "inherit",
      fontSize: "inherit"
    },
    "--Icon-margin": 0,
    fontSize: "inherit",
    marginLeft: 0,
    marginRight: t.spacing(0.5)
  },
  color: "inherit",
  fontSize: "0.875rem",
  fontWeight: "normal",
  lineHeight: "1rem",
  minHeight: "auto",
  padding: t.spacing(0.5)
})), f = a(({
  children: t,
  ...i
}) => /* @__PURE__ */ o.jsx(s, { startDecorator: /* @__PURE__ */ o.jsx(n, { fixedWidth: !0, icon: r }), ...i, children: t }));
f.displayName = "ShowRowsButton";
export {
  f as default
};
//# sourceMappingURL=ShowRowsButton.js.map
